/**
 * Affiliations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";

// States
const state = {
    comptables: [],
    comptable: {}
};

// Getters
const getters = {
    comptables: state => {
        return state.comptables
    },

    comptable: state => {
        return state.comptable
    }
};

// Actions
const actions = {
    getComptables(context, payload) {
        function successCallback(response) {
            context.commit('getComptablesHandler', { comptables: response.data.comptables });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Comptable.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getComptable(context, payload) {
        function successCallback(response) {
            context.commit('getComptableHandler', { comptable: response.data.comptable });
        }

        function errorCallback(error) {

            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Comptable.Get, localToken, successCallback, errorCallback, payload.errorMessages);

    },

    createComptable(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'accountant', params: { accountant: response.data.comptable.slug } });
        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Comptable.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateComptable(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'comptable' });
            router.push({ name: 'accountant', params: { accountant: response.data.comptable.slug } });

        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Comptable.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteComptable(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'accountant' });
            router.push({ name: 'accountants' });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Comptable.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getComptablesHandler(state, { comptables }) {
        // Update affiliations state
        state.comptables = comptables;
    },

    getComptableHandler(state, { comptable }) {
        // Update affiliation state
        state.comptable = comptable;
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}